import { IPermissionProps } from '@/types/shared'
import { useParams } from 'react-router-dom'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { GridInformationWithHookForm } from 'vnetwork-ui'
import SubHeaders from '@/components/Headers/SubHeaders'
import { paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import useDataGridRefetch from '@/hooks/useDataGridRefetch'
import PeopleIcons from '@/icons/PeopleIcons'
import { getJobCategory, updateJobCategory } from '../../services'
import { JobCategory } from '../../types'
import { createJobCategorySchema } from '../Create/yup'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const Update: React.FC<IPermissionProps> = () => {
    const { jobCategoryID } = useParams<{ jobCategoryID: string }>()
    const { t } = useTranslation()
    const { refetchCurrent } = useDataGridRefetch({
        reactQueryKey: 'job-categories',
    })
    const {
        data: jobCategory,
        refetch,
        renderState,
    } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.JOB_CATEGORY_DETAIL, jobCategoryID],
        queryFn: async () => {
            const result = await getJobCategory(Number(jobCategoryID))
            return result
        },
    })

    const handleEdit = async (values: JobCategory) => {
        console.log('values', values)
        await updateJobCategory({
            id: Number(jobCategoryID),
            jobCategory: values,
        })
        refetchCurrent()
    }

    const { mutateAsync: updatejobMutation } = useMutationWithHandler(
        {
            mutationFn: handleEdit,
        },
        {
            reactQueryKeys: QUERY_KEYS.JOBS,
            successMessage: t('updated-success'),
            onSuccess: () => {
                refetch()
            },
        }
    )

    const stateComponent = renderState()
    if (stateComponent) return stateComponent
    return (
        <>
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    {
                        path: '/job-categories',
                        title: t('job-categories-list'),
                    },
                    {
                        path: `${paths.jobCategoryList}/${jobCategory?.result?.id}`,
                        title: t('job-category-information'),
                    },
                ]}
            />

            <GridInformationWithHookForm
                defaultFormValues={{
                    title: jobCategory?.result?.title || '',
                    description: jobCategory?.result?.description || '',
                }}
                onEdit={updatejobMutation}
                schema={createJobCategorySchema as any}
                data={[
                    {
                        label: t('job-category-title'),
                        value: jobCategory?.result?.title,
                        formItemProps: {
                            name: 'title',
                            type: 'textfield',
                        },
                    },
                    {
                        label: t('job-category-description'),
                        value: jobCategory?.result?.description,
                        className: 'col-span-3',
                        formItemProps: {
                            name: 'description',
                            type: 'textfield',
                            className: 'col-span-3',
                        },
                    },
                ]}
                head={{
                    title: t('job-category-information'),
                    icon: <PeopleIcons />,
                }}
            />
        </>
    )
}

export default Update
